import styled from 'styled-components';

export const LabelPreview = styled.div`
	position: absolute;
    bottom: 38px;
	line-height: 20px;
	color: #175eb8;
	width: 150px;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    border-radius: 5px;
    display: flex;
    line-height: 20px;
	cursor: default;
	> .text {
		width: 100%;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		text-align: left;
		min-height: 20px;
	}
	
`;

export const LabelPreviewExpanded = styled.div`
	position: absolute;
    bottom: 42px;
	left: -10px;
	${props => props.firstNode === true && 'left: 0px'};
	line-height: 20px;
	color: #175eb8;
	width: 170px;
	height: 100px;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    border-radius: 5px;
    display: flex;
    line-height: 20px;
    border : 1px solid;
	flex-direction: column;
    justify-content: center;
    /* padding: 4px; */
	cursor: text;
	::after {
		position: absolute;
		content: "";
		width: 10px;
		height: 10px;
		border-top: 0px solid;
		border-right: 1px solid;
		border-bottom: 1px solid;
		border-left: 0px solid;
		top: 100%;
		left: 50%;
		margin-left: -5px;
		margin-top: -4px;
		transform: rotate(45deg);
		background: #fff;
	}
	
`;

export const WrapperExpanded = styled.div`
	display : flex;
	width: 100%;
	height: 100%;
	flex-direction: column;
    overflow: auto;
	padding: 4px;
	margin: 4px 0px;
`;
export const WrapperItemPreview = styled.div`
	display : flex;
	flex-wrap: nowrap;
	> .text {
		width: 100%;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		text-align: left;
		min-height: 20px;
	}
	> .label {
		color: #222f3e;
		margin-right: 4px;
		white-space: nowrap;
	}
`;